import type { ApiError, BookingReassignmentAvailabilityStatus } from '@/shared/api';

const problemTexts: Record<string, string> = {
  booking_reassignment_not_ready:
    'Umbuchungen werden für dieses Objekt noch vorbereitet. Bitte später erneut versuchen.',
  booking_reassignment_invalid: 'Die Angaben für den Apartmentwechsel sind unvollständig.',
  booking_reassignment_same_property: 'Bitte ein anderes Apartment auswählen.',
  booking_reassignment_cross_object: 'Umbuchungen sind nur innerhalb desselben Objekts möglich.',
  booking_reassignment_target_inactive: 'Das Ziel-Apartment ist nicht aktiv.',
  booking_reassignment_target_occupied:
    'Das Ziel ist belegt und kann nicht eindeutig als Tausch erkannt werden.',
  booking_reassignment_target_blocked: 'Das Ziel ist im gewählten Zeitraum gesperrt.',
  booking_reassignment_invoice_template_mismatch:
    'Die Apartments verwenden unterschiedliche Rechnungsvorlagen.',
  booking_reassignment_cleaning_started:
    'Die Reinigung für diesen Aufenthalt wurde bereits begonnen oder abgeschlossen.',
  booking_reassignment_status_forbidden: 'Der Status dieser Buchung erlaubt keine Umbuchung.',
  booking_reassignment_stay_completed: 'Der Aufenthalt ist bereits abgeschlossen.',
  booking_reassignment_swap_invalid:
    'Die Gegenbuchung passt nicht mehr zum gewählten Ziel. Bitte erneut prüfen.',
  booking_reassignment_operation_mismatch:
    'Der vorige Versuch hatte andere Angaben. Bitte den Dialog neu öffnen.',
  booking_not_found: 'Die Buchung wurde nicht gefunden oder ist nicht mehr verfügbar.',
  property_not_found: 'Das Apartment wurde nicht gefunden oder ist nicht mehr verfügbar.',
  property_timezone_invalid: 'Die Zeitzone des Objekts ist ungültig konfiguriert.',
};

/** Diese Ablehnungen nennen das belegte Apartment; nur der Server kennt es und darf es nennen. */
const serverWords: Record<string, string> = {
  booking_reassignment_target_flat_family:
    'Das Ziel ist im gewählten Zeitraum durch den Wohnungsverbund belegt.',
};

export function reassignmentProblemText(problem: ApiError): string {
  if (problem.title in serverWords) return problem.detail ?? serverWords[problem.title]!;
  return problemTexts[problem.title] ?? problem.detail ?? problem.title;
}

export function availabilityStatusLabel(status: BookingReassignmentAvailabilityStatus): string {
  const labels: Record<BookingReassignmentAvailabilityStatus, string> = {
    NotRequired: 'Keine Kanalübertragung nötig',
    Pending: 'Übertragung läuft',
    Confirmed: 'Von Channex bestätigt',
    Failed: 'Übertragung fehlgeschlagen',
  };
  return labels[status];
}

export function unchangedStayLabel(checkInDate: string, checkOutDate: string): string {
  const format = (value: string) =>
    new Intl.DateTimeFormat('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(`${value}T00:00:00Z`));
  return `Aufenthalt unverändert: ${format(checkInDate)} – ${format(checkOutDate)}`;
}
